export const clip = (value: string | null | undefined, max: number) => String(value ?? '').slice(0, max)

export const onlyLetters = (value: string, max: number) => clip(value, max).replace(/[^a-zA-ZáéíóúÁÉÍÓÚüÜñÑ ]/g, '')

export const isEmail = (value: string | null | undefined) => /^\S+@\S+\.\S+$/.test(String(value ?? ''))

export const onlySimple = (value: string, max: number) => clip(value, max).replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]/g, '')
